import { gql } from '@apollo/client'

export default {
  imageTotal: gql`
    query ImageTotal {
      imageTotal {
        start
        deltaPerMilli
      }
    }
  `,
}
